import { createI18n, getActiveI18n, t as translate } from "@magic-md/i18n";
import type { LocaleBundles, LocaleParams } from "@magic-md/i18n";
import { useI18n, useT } from "@magic-md/i18n/react";
import { useMemo } from "react";

const PLUGIN_SDK_NAMESPACE = "pluginSdk";

export type MagicMdTranslate = (key: string, params?: LocaleParams) => string;

export function usePluginSdkT(): MagicMdTranslate {
    return useT(PLUGIN_SDK_NAMESPACE);
}

export function pluginSdkT(key: string, params?: LocaleParams): string {
    return translate(PLUGIN_SDK_NAMESPACE, key, params);
}

export function useMagicMdT(
    namespace: string,
    bundles: LocaleBundles,
): MagicMdTranslate {
    const active = useI18n();
    return useMemo(() => {
        const i18n = createI18n({
            requestedLocale: active.locale,
            fallbackLocale: active.fallbackLocale,
            bundles,
        });
        return (key: string, params?: LocaleParams) => i18n.t(namespace, key, params);
    }, [active.fallbackLocale, active.locale, bundles, namespace]);
}

export function magicMdT(
    namespace: string,
    key: string,
    params: LocaleParams,
    bundles: LocaleBundles,
): string {
    const active = getActiveI18n();
    return createI18n({
        requestedLocale: active.locale,
        fallbackLocale: active.fallbackLocale,
        bundles,
    }).t(namespace, key, params);
}
